import React, { useRef, useEffect } from 'react';
import cx from 'classnames';
import { connect, Provider } from 'react-vuex';
import tippy from 'tippy.js';

import vuexStore from '../../shared/store';
import { EventBus } from '../../shared/event-bus';

function mapDispatchToProps(dispatch) {
  return {
    addItemToCart: (product) => dispatch('cart/addItem', product),
  };
}

function mapGetterToProps(getters, ownProps) {
  const { product } = ownProps;
  return {
    cartIsFull: getters['cart/full'],
    isAlreadyAdded: getters['cart/contains']({
      id: product.id,
      type: product.type,
    }),
  };
}

// Sorry future people.
const _AddToCartButton = connect(
  () => ({}),
  mapDispatchToProps,
  () => ({}),
  mapGetterToProps
)(
  ({
    product,
    hideIcon,
    className,
    cartIsFull,
    isAlreadyAdded,
    addItemToCart,
  }) => {
    const containerRef = useRef(null);

    // Add a tooltip on the button indicating why it is disabled, when relevant
    useEffect(() => {
      if (!cartIsFull) {
        return;
      }

      const tooltips = tippy(containerRef.current, {
        arrow: true,
        placement: 'top',
        content: 'You can only add five items per order'
          // : 'You can only add a specific item once per order',
      });

      return () => {
        tooltips.destroyAll();
      };
    }, [containerRef, cartIsFull, isAlreadyAdded]);

    function addToCart(event) {
      if (cartIsFull) {
        return;
      }

      // Hide the overflow when on mobile to stop double scrollbars
      const mobileMenu = document.querySelector('#toggle-mobile-navbar');
      const displayStyle = window.getComputedStyle(mobileMenu).display;
      if (displayStyle !== 'none') {
        // We are on mobile so we want to hide the overflow
        document.querySelector('body').classList.toggle("overflow-hidden")
      }

      const { description, price, id, type, url, regionName } = product;

      // The button is sometimes nested in clickable cards, which we don't
      // want to click when adding an item to the cart.
      event.stopPropagation();

      addItemToCart({
        description,
        price,
        extra: { id, type, url, regionName },
      });
      EventBus.$emit('item-added-to-cart');
    }

    return (
      <a
        className={cx(
          hideIcon ? 'simple-btn' : 'btn',
          'btn-gold',
          cartIsFull && 'btn-disabled cursor-not-allowed',
          className
        )}
        onClick={addToCart}
        ref={containerRef}
      >
        {hideIcon ? (
          'Add to Cart'
        ) : (
          <React.Fragment>
            <span className="btn-content">Add to Cart</span>
            <span className="icon">
              <i
                className={cartIsFull ? 'fas fa-check' : 'fas fa-shopping-cart'}
                aria-hidden="true"
              />
            </span>
          </React.Fragment>
        )}
      </a>
    );
  }
);

export const AddToCartButton = (props) => (
  <Provider store={vuexStore}>
    <_AddToCartButton {...props} />
  </Provider>
);
